import { focusManager, onlineManager } from '@tanstack/react-query';
import { useMemo, useRef } from 'react';
export function useSidebarQueryRecovery({ refetchOnWindowFocus = false, } = {}) {
    const deferred = useRef(null);
    return useMemo(() => ({
        refetchOnReconnect: (query) => {
            const visible = focusManager.isFocused();
            // hidden tabs must not all refresh the same viewer's sidebar on reconnect.
            deferred.current = visible
                ? null
                : { queryHash: query.queryHash, dataUpdateCount: query.state.dataUpdateCount };
            return visible;
        },
        refetchOnWindowFocus: (query) => {
            if (!onlineManager.isOnline())
                return false;
            const pending = deferred.current;
            deferred.current = null;
            // a new page, explicit refresh, or live write can already satisfy recovery.
            return (refetchOnWindowFocus ||
                (pending?.queryHash === query.queryHash &&
                    pending.dataUpdateCount === query.state.dataUpdateCount));
        },
    }), [refetchOnWindowFocus]);
}
//# sourceMappingURL=useSidebarQueryRecovery.js.map